import { cleanURL } from "../helpers/cleanUrl";

const TBODY_ID = "data_stores";

/**
 * Create headTable
 * @param {object} labels
 */
export const createTable = (labels = {}) => {
  if (!labels) return;
  const container = document.createElement("div");
  container.classList.add("tableContainer");
  // table
  const table = document.createElement("table");
  table.classList.add("stores_table");
  // thead
  const thead = document.createElement("thead");
  // tr
  const tr = document.createElement("tr");
  // th
  Object.keys(labels.table).forEach((l) => {
    const th = document.createElement("th");
    th.setAttribute("valign", "middle");
    th.setAttribute("role", "columnheader");
    th.setAttribute("scope", "col");
    th.classList.add(l);

    th.textContent = labels.table[l];
    tr.appendChild(th);
  });
  thead.appendChild(tr);
  // tbody
  const tbody = document.createElement("tbody");
  tbody.id = TBODY_ID;
  table.appendChild(thead);
  table.appendChild(tbody);
  container.appendChild(table);
  return container;
};

/**
 * delete all children
 * @param {node} parent
 */
const removeAllChildNodes = (parent) => {
  while (parent.firstChild) {
    parent.removeChild(parent.firstChild);
  }
};

const getContent = (content, labels) => {
  return content === true
    ? labels.others.true
    : content === false
    ? labels.others.false
    : content;
};

/**
 * insert array of element in td
 */
const insertArrayNode = (td, content, labels) => {
  content.forEach((c) => {
    if (typeof c === "string") {
      const span = document.createElement("span");
      span.textContent = c;
      td.appendChild(span);
    } else if (typeof c === "boolean") {
      const _content = getContent(c, labels);
      const span = document.createElement("span");
      span.appendChild(document.createTextNode(_content));
      td.appendChild(span);
    } else if (Array.isArray(c)) {
      const sp = document.createDocumentFragment();
      c.forEach((e) => {
        if (e.href) {
          const a = document.createElement("a");
          a.setAttribute("target", "_blank");
          a.href = e.href;
          a.textContent = cleanURL(e.href);
          sp.appendChild(a);
        }
      });
      td.appendChild(sp);
    } else {
      td.appendChild(c);
    }
    // td.appendChild(document.createElement("br"));
  });
};

// create label element
const getLabel = (text) => {
  if (text !== "") {
    const span = document.createElement("span");
    span.classList.add("colHeader");
    span.textContent = text + ": ";
    return span;
  }
};

/**
 * create th element
 *
 * @param {string} key
 * @param {string|array} content
 */
const getTH = (content, labels, mobile = false) => {
  const td = document.createElement("td");
  td.setAttribute("role", "cell");
  if (mobile) {
    td.setAttribute("valign", "top");
  } else {
    td.setAttribute("valign", "middle");
  }
  td.classList.add(mobile ? "mobile-only" : "desktop-only");

  // if nodes array
  if (Array.isArray(content)) {
    insertArrayNode(td, content, labels);
  } else {
    const _content = getContent(content, labels);
    const text = document.createTextNode(_content);
    td.appendChild(text);
  }
  return td;
};

/**
 * insert data line in table
 * @param {array} data
 * @param {object} labels
 * @param {function} cd - onclick row
 */
export const updateData = (data = [], labels = {}, cb = () => {}) => {
  if (!labels || !data) return;
  const tbody = document.getElementById(TBODY_ID);
  if (tbody) {
    removeAllChildNodes(tbody);
  }
  data.forEach((e) => {
    // list of link
    const links = e.urls.map((url) => {
      const a = document.createElement("a");
      a.setAttribute("target", "_blank");
      a.href = url;
      a.textContent = cleanURL(url);
      return a;
    });

    const tr = document.createElement("tr");
    tr.classList.add("row");
    tr.setAttribute("role", "row");
    // cells

    // mobile cells
    tr.appendChild(
      getTH(
        [getLabel(labels.table.title), e.title, e.address, e.city, links],
        labels,
        true
      )
    );

    tr.appendChild(
      getTH(
        [
          getLabel(labels.table.online),
          e.online,
          document.createElement("div"),
          getLabel(labels.table.automate),
          e.automate,
        ],
        labels,
        true
      )
    );

    // desktop cells
    tr.appendChild(getTH(e.title, labels));
    tr.appendChild(getTH(e.address, labels));
    tr.appendChild(getTH(e.city, labels));
    tr.appendChild(getTH(e.automate, labels));
    tr.appendChild(getTH(e.online, labels));
    tr.appendChild(getTH(links, labels));

    tbody.appendChild(tr);
    // event and dataset title
    tr.addEventListener("click", cb);
    tr.dataset.title = e.title;
  });
};
